import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Twitch } from 'lucide-react';

// Roll command multiplier thresholds
const ROLL_MULTIPLIERS = [
  { range: '1-25', multiplier: 'x1 point' },
  { range: '26-50', multiplier: 'x2 points' },
  { range: '51-75', multiplier: 'x3 points' },
  { range: '76-98', multiplier: 'x4 points' },
  { range: '99-100', multiplier: 'x10 points' },
];

// Carl command multiplier thresholds
const CARL_MULTIPLIERS = [
  { condition: '3x CarlSmile', multiplier: 'x10 points' },
  { condition: '3 of a kind', multiplier: 'x8 points' },
  { condition: '3+', multiplier: 'x5 points' },
  { condition: '2+', multiplier: 'x3 points' },
  { condition: '1+', multiplier: 'x2 points' },
  { condition: '0+', multiplier: 'x0 points', isZero: true },
];

export const EarnPointsSection = () => (
  <section className="py-12 sm:py-20 px-4">
    <div className="max-w-7xl mx-auto">
      <SectionHeader />
      <EarnPointsCard />
    </div>
  </section>
);

const SectionHeader = () => (
  <div className="text-center mb-12">
    <h2 className="text-4xl sm:text-5xl md:text-6xl font-black game-show-text mb-4">
      HOW TO EARN POINTS
    </h2>
    <p className="text-xl sm:text-2xl text-blue-300 font-bold mb-6">
      Watch 5 minutes = Earn 1 point
    </p>
    <div className="max-w-3xl mx-auto space-y-2">
      <p className="text-lg sm:text-xl text-gray-200 font-bold">
        Use points in chat games to acquire more points!
      </p>
      <p className="text-lg sm:text-xl text-gray-200 font-bold">
        Chat with viewers and CiroGameShow
      </p>
    </div>
  </div>
);

const EarnPointsCard = () => (
  <Card className="points-card border-4 max-w-4xl mx-auto">
    <CardContent className="p-6 sm:p-8">
      <div className="mb-8">
        <h3 className="text-2xl sm:text-3xl font-black text-blue-400 mb-6 text-center">
          Play These Chat Games:
        </h3>
        <RollCommand />
        <CarlCommand />
      </div>
      <StartEarningButton />
    </CardContent>
  </Card>
);

const StartEarningButton = () => (
  <div className="text-center">
    <a 
      href="https://www.twitch.tv/cirogameshowtwitch"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
    >
      <Button 
        size="lg" 
        className="text-xl font-black py-6 px-8 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 border-4 border-blue-400 pulse-button"
      >
        <Twitch className="mr-3 w-6 h-6" />
        START EARNING IN CHAT
      </Button>
    </a>
  </div>
);

const RollCommand = () => (
  <div className="mb-8 p-6 bg-gradient-to-r from-blue-900/40 to-blue-800/40 rounded-lg border-2 border-blue-500">
    <h4 className="text-xl sm:text-2xl font-black text-white mb-3">!roll (1-10)</h4>
    <p className="text-gray-200 mb-2 font-bold">Type !roll (1-10) or !ol (1-10) to win points</p>
    <p className="text-gray-400 text-sm mb-4">Cooldown: 30 seconds</p>
    <div className="space-y-2">
      <p className="text-blue-300 font-bold text-lg mb-2">Reward Multipliers:</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {ROLL_MULTIPLIERS.map(({ range, multiplier }) => (
          <p key={range} className="text-gray-200">
            {range}: <span className="text-gray-100 font-black">{multiplier}</span>
          </p>
        ))}
      </div>
    </div>
  </div>
);

const CarlCommand = () => (
  <div className="p-6 bg-gradient-to-r from-slate-800/40 to-blue-900/40 rounded-lg border-2 border-gray-400">
    <h4 className="text-xl sm:text-2xl font-black text-white mb-3">!carl (1-25)</h4>
    <p className="text-gray-200 mb-2 font-bold">Type !carl (1-25) to win points with emote combinations</p>
    <p className="text-gray-400 text-sm mb-4">Cooldown: 30 seconds</p>
    <div className="space-y-2">
      <p className="text-blue-300 font-bold text-lg mb-2">Reward Multipliers:</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {CARL_MULTIPLIERS.map(({ condition, multiplier, isZero }) => (
          <p key={condition} className="text-gray-200">
            {condition}: <span className={`font-black ${isZero ? 'text-gray-400' : 'text-gray-100'}`}>{multiplier}</span>
          </p>
        ))}
      </div>
      <p className="text-sm text-gray-300 mt-4">
        9 emotes: BabyRage(-), BibleThump(-), Kappa(-), MrDestructoid(-), VoteNay(-), bleedPurple(+), CarlSmile(+), imGlitch(+), VoteYea(+)
      </p>
    </div>
  </div>
);
